"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
class AiMessageProvider extends DataProvider_1.default {
    get fragments() {
        return {
            AiMessage: () => `
        ... on AiMessage {
          text
          requesterId
          threadId
          fileIds
          files {
            ${this.getFragment("VaultFile")}
          }
        }
      `,
        };
    }
    messageGenerate({ data }) {
        return this.query("aiMessageGenerate", { data });
    }
    subscribeToThread(threadId, onData, onError) {
        return this.api.subscribe({
            query: graphql_tag_1.default `
          subscription($threadId: ID!) {
            aiMessageGenerated(threadId: $threadId) {
              ${this.getFragment("AiMessage")}
            }
          }
        `,
            variables: { threadId },
        }, data => {
            onData(data.aiMessageGenerated);
        }, onError);
    }
}
exports.AiMessageProvider = AiMessageProvider;
//# sourceMappingURL=AiMessage.js.map